// Google Analytics ID is stored in .env, .env.development in app root
const GoogleAnalyticsHelper = () => {
	const gtag = window.gtag || false;
	const gaId = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;

	return {
		sendPageView() {
			if (gtag) {
				gtag('event', 'page_view', {
					page_location: window.location.origin,
					page_path: window.location.pathname,
					send_to: gaId
				});
			}
		}
	};
};

export default GoogleAnalyticsHelper();
